import { render } from "./Justificativas.vue?vue&type=template&id=136cdaa9"
import script from "./Justificativas.vue?vue&type=script&lang=js"
export * from "./Justificativas.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DealDesk\\Homologação\\Mult_Cliente\\front_mult_clint\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__